import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type WorkRequestEvents =
  | 'DELETE_FROM_TABLE'
  | 'DELETE_FROM_DETAILS'
  | 'ACTION_SELECTION'
  | 'WORK_REQUEST_HUB_CLICK_WORK_REQUEST_TITLE'
  | 'WORK_REQUEST_HUB_CLICK_WORK_REQUEST_ID'
  | 'WORK_REQUEST_HUB_CLICK_WORK_REQUEST_WORK_REQUESTING_PARTY'
  | 'WORK_REQUEST_HUB_CLICK_WORK_REQUEST_REQUESTOR'
  | 'WORK_REQUEST_TOOLBAR_ADD_WORK_REQUEST'
  | 'WORK_REQUEST_HUB_START_SEARCH_BAR'
  | 'WORK_REQUEST_SELECT_NEW_ADD_WORK_REQUEST_BUTTON'
  | 'WORK_REQUEST_CLICK_EXPORT_DROPDOWN_BUTTON'
  | 'WORK_REQUEST_CLICK_EXPORT_EXCEL_BUTTON'
  | 'WORK_REQUEST_CLICK_EXPORT_CSV_BUTTON'
  | 'WORK_REQUEST_CLICK_IMPORT_BUTTON'
  | 'WORK_REQUEST_FILTER_BUTTON'
  | 'WORK_REQUEST_FILTER_STATUS'
  | 'WORK_REQUEST_FILTER_TYPE'
  | 'WORK_REQUEST_DETAILS_DETAILS_TAB'
  | 'WORK_REQUEST_DETAILS_TABS_CLICK'
  | 'WORK_REQUEST_DETAILS_PROCESSES_TAB'
  | 'WORK_REQUEST_CLICK_PROCESS_ENTITY_DESCRIPTOR'
  | 'WORK_REQUEST_HUB_CLICK_DELETE_WORK_REQUEST_OVERFLOW_ACTION'
  | 'WORK_REQUEST_HUB_CLICK_EDIT_PROCESS_OVERFLOW_ACTION'
  | 'WORK_REQUEST_HUB_CLICK_CHANGE_HISTORY_OVERFLOW_ACTION'
  | 'EXPORT_WORK_REQUEST_RESULT';

export const workRequest: Record<WorkRequestEvents, MixpanelEvent> = {
  DELETE_FROM_TABLE: {
    eventDescription: 'Delete WorkRequest (Table)',
    eventKey: 'work-request-delete-table',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  DELETE_FROM_DETAILS: {
    eventDescription: 'Delete WorkRequest (Details)',
    eventKey: 'work-request-delete-details',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  ACTION_SELECTION: {
    eventKey: 'work-request-hub-action_selection',
    eventDescription: 'User selected action from the overflow menu',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  WORK_REQUEST_HUB_CLICK_WORK_REQUEST_TITLE: {
    eventKey: 'work-request-hub-click-work-request-title',
    eventDescription: 'User clicks work request title in work request hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  WORK_REQUEST_HUB_CLICK_WORK_REQUEST_ID: {
    eventKey: 'work-request-hub-click-work-request-id',
    eventDescription: 'User clicks work request id in work request hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  WORK_REQUEST_HUB_CLICK_WORK_REQUEST_WORK_REQUESTING_PARTY: {
    eventKey: 'work-request-hub-click-work-request-work-requesting-party',
    eventDescription: 'User clicks work request parent work requesting party in work request hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  WORK_REQUEST_HUB_CLICK_WORK_REQUEST_REQUESTOR: {
    eventKey: 'work-request-hub-click-work-request-requestor',
    eventDescription: 'User clicks work request requestor in work request hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  WORK_REQUEST_TOOLBAR_ADD_WORK_REQUEST: {
    eventKey: 'work-request-hub-toolbar-add-work-request',
    eventDescription: 'User clicks add work request from work request hub toolbar',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.APP_TOOLBAR_BUTTON
  },
  WORK_REQUEST_HUB_START_SEARCH_BAR: {
    eventKey: 'work-request-hub-click-search-bar-and-starts-search',
    eventDescription: 'User clicks search bar in work requests hub and starts search',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SEARCH_INPUT
  },
  WORK_REQUEST_SELECT_NEW_ADD_WORK_REQUEST_BUTTON: {
    eventKey: 'work-request-click-add-new-work-request-select',
    eventDescription: 'User clicks select button to add new work request and start page flow',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_CLICK_EXPORT_DROPDOWN_BUTTON: {
    eventKey: 'work-request-click-export-dropdown-button',
    eventDescription: 'User clicks export to dropdown button in work requests hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_CLICK_EXPORT_EXCEL_BUTTON: {
    eventKey: 'work-request-click-export-excel-button',
    eventDescription: 'User clicks export to excel button in work requests hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_CLICK_EXPORT_CSV_BUTTON: {
    eventKey: 'work-request-click-export-csv-button',
    eventDescription: 'User clicks export to csv button in work requests hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_CLICK_IMPORT_BUTTON: {
    eventKey: 'work-request-click-import-button',
    eventDescription: 'User clicks import button in work requests hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_FILTER_BUTTON: {
    eventKey: 'work-request-click-toolbar-filter-button',
    eventDescription: 'User clicks toolbar filter button in work requests hub',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_FILTER_STATUS: {
    eventKey: 'work-request-click-filter-status-select',
    eventDescription: 'User clicks work request filter status input',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_FILTER_TYPE: {
    eventKey: 'work-request-click-filter-type-select',
    eventDescription: 'User clicks work request filter type option',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_DETAILS_DETAILS_TAB: {
    eventKey: 'work-request-details-page-view-details',
    eventDescription: 'User views work request details tab in work request details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_DETAILS_TABS_CLICK: {
    eventKey: 'work-request-details-tabs-click',
    eventDescription: 'contract details tabs click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SUB_MENU_BUTTON
  },
  WORK_REQUEST_DETAILS_PROCESSES_TAB: {
    eventKey: 'work-request-details-page-view-processes',
    eventDescription: 'User views work request processes tab in work request details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_CLICK_PROCESS_ENTITY_DESCRIPTOR: {
    eventKey: 'work-request-details-page-processes-user-click-entity-descriptor',
    eventDescription: 'User clicks entity descriptor in processes tab in work request details page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_HUB_CLICK_DELETE_WORK_REQUEST_OVERFLOW_ACTION: {
    eventKey: 'work-request-hub-user-click-delete-work-request',
    eventDescription: 'User clicks delete work request overflow action',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_HUB_CLICK_EDIT_PROCESS_OVERFLOW_ACTION: {
    eventKey: 'work-request-hub-user-click-edit-work-request',
    eventDescription: 'User clicks edit work request overflow action',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  WORK_REQUEST_HUB_CLICK_CHANGE_HISTORY_OVERFLOW_ACTION: {
    eventKey: 'work-request-hub-user-click-view-work-request-change-history',
    eventDescription: 'User clicks view work request change history overflow action',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  },
  EXPORT_WORK_REQUEST_RESULT: {
    eventKey: 'click-work-request-quick-report-export',
    eventDescription: 'User clicks work request quick report export',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  }
} as const;
